'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var extractDataFromBlock = require('../../../utils/extract-data-from-block');

var validateOffsetAndLength = require('../../../utils/validate-offset-and-length');

var UnixFS = require('ipfs-unixfs');

var errCode = require('err-code');

function emitBytes(_x, _x2, _x3, _x4) {
  return _emitBytes.apply(this, arguments);
}

function _emitBytes() {
  _emitBytes = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipld, node, start, end) {
    var streamPosition,
        options,
        buf,
        file,
        nodeHasData,
        _buf,
        childStart,
        i,
        childLink,
        childEnd,
        child,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _value,
        _buf2,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            streamPosition = _args.length > 4 && _args[4] !== undefined ? _args[4] : 0;
            options = _args.length > 5 ? _args[5] : undefined;

            if (!Buffer.isBuffer(node)) {
              _context.next = 9;
              break;
            }

            buf = extractDataFromBlock(node, streamPosition, start, end);

            if (!buf.length) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return buf;

          case 7:
            streamPosition += buf.length;
            return _context.abrupt("return", streamPosition);

          case 9:
            _context.prev = 9;
            file = UnixFS.unmarshal(node.Data);
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](9);
            throw errCode(_context.t0, 'ERR_NOT_UNIXFS');

          case 16:
            // might be a unixfs `raw` node or have data on intermediate nodes
            nodeHasData = Boolean(file.data && file.data.length);

            if (!nodeHasData) {
              _context.next = 23;
              break;
            }

            _buf = extractDataFromBlock(file.data, streamPosition, start, end);

            if (!_buf.length) {
              _context.next = 22;
              break;
            }

            _context.next = 22;
            return _buf;

          case 22:
            streamPosition += file.data.length;

          case 23:
            childStart = streamPosition; // work out which child nodes contain the requested data

            i = 0;

          case 25:
            if (!(i < node.Links.length)) {
              _context.next = 72;
              break;
            }

            childLink = node.Links[i];
            childEnd = streamPosition + file.blockSizes[i];

            if (!(start >= childStart && start < childEnd || // child has offset byte
            end > childStart && end <= childEnd || // child has end byte
            start < childStart && end > childEnd)) {
              _context.next = 67;
              break;
            }

            _context.next = 31;
            return _awaitAsyncGenerator(ipld.get(childLink.Hash, options));

          case 31:
            child = _context.sent;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 34;
            _iterator = _asyncIterator(emitBytes(ipld, child, start, end, streamPosition, options));

          case 36:
            _context.next = 38;
            return _awaitAsyncGenerator(_iterator.next());

          case 38:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 42;
            return _awaitAsyncGenerator(_step.value);

          case 42:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 51;
              break;
            }

            _buf2 = _value;
            streamPosition += _buf2.length;
            _context.next = 48;
            return _buf2;

          case 48:
            _iteratorNormalCompletion = true;
            _context.next = 36;
            break;

          case 51:
            _context.next = 57;
            break;

          case 53:
            _context.prev = 53;
            _context.t1 = _context["catch"](34);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 57:
            _context.prev = 57;
            _context.prev = 58;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 62;
              break;
            }

            _context.next = 62;
            return _awaitAsyncGenerator(_iterator.return());

          case 62:
            _context.prev = 62;

            if (!_didIteratorError) {
              _context.next = 65;
              break;
            }

            throw _iteratorError;

          case 65:
            return _context.finish(62);

          case 66:
            return _context.finish(57);

          case 67:
            streamPosition = childEnd;
            childStart = childEnd + 1;

          case 69:
            i++;
            _context.next = 25;
            break;

          case 72:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 13], [34, 53, 57, 67], [58,, 62, 66]]);
  }));
  return _emitBytes.apply(this, arguments);
}

var fileContent = function fileContent(cid, node, unixfs, path, resolve, depth, ipld) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fileSize = unixfs.fileSize();

    var _validateOffsetAndLen = validateOffsetAndLength(fileSize, options.offset, options.length),
        offset = _validateOffsetAndLen.offset,
        length = _validateOffsetAndLen.length;

    var start = offset;
    var end = offset + length;
    return emitBytes(ipld, node, start, end, 0, options);
  };
};

module.exports = fileContent;